import { render, staticRenderFns } from "./merge_requests_list_app.vue.js?vue&type=template&id=5b62fff7!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./merge_requests_list_app.vue?vue&type=template&id=5b62fff7"
import script from "./merge_requests_list_app.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./merge_requests_list_app.vue?vue&type=script&lang=js"
export * from "./merge_requests_list_app.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./merge_requests_list_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports